import React from 'react';
/* Children */

import Children from './Children/Children';
import ChildrenBoys from './Children/ChildrenBoys';
import ChildrenGirls from './Children/ChildrenGirls';
import ChildrenShoes from './Children/ChildrenShoes';
/* Mens */

import MensClothing from './Mens/MensClothing';
import MensDual from './Mens/MensDual';
import MensDualBottoms from './Mens/MensDualBottoms';
import MensDualTops from './Mens/MensDualTops';
import MensShirts from './Mens/MensShirts';
import MensShoes from './Mens/MensShoes';
/* Womens */

import WomensClothing from './Womens/WomensClothing';
import WomensDualBottoms from './Womens/WomensDualBottoms';
import WomensDualTops from './Womens/WomensDualTops';
import WomensLingerie from './Womens/WomensLingerie';
import WomensShoes from './Womens/WomensShoes';
/* The IDs */

import CategoryIds from './categoryIds';
var categories = [{
  ids: CategoryIds.Children,
  table: /*#__PURE__*/React.createElement(Children, {
    key: "childrens-clothes"
  })
}, {
  ids: CategoryIds.ChildrenBoys,
  table: /*#__PURE__*/React.createElement(ChildrenBoys, {
    key: "childrens-boys"
  })
}, {
  ids: CategoryIds.ChildrenGirls,
  table: /*#__PURE__*/React.createElement(ChildrenGirls, {
    key: "childrens-girls"
  })
}, {
  ids: CategoryIds.ChildrenShoes,
  table: /*#__PURE__*/React.createElement(ChildrenShoes, {
    key: "childrens-shoes"
  })
}, {
  ids: CategoryIds.MensClothing,
  table: /*#__PURE__*/React.createElement(MensClothing, {
    key: "mens-clothing"
  })
}, {
  ids: CategoryIds.MensDual,
  table: /*#__PURE__*/React.createElement(MensDual, {
    key: "mens-dual-clothing"
  })
}, {
  ids: CategoryIds.MensDualBottoms,
  table: /*#__PURE__*/React.createElement(MensDualBottoms, {
    key: "mens-dual-bottoms"
  })
}, {
  ids: CategoryIds.MensDualTops,
  table: /*#__PURE__*/React.createElement(MensDualTops, {
    key: "mens-dual-tops"
  })
}, {
  ids: CategoryIds.MensShirts,
  table: /*#__PURE__*/React.createElement(MensShirts, {
    key: "mens-shirts"
  })
}, {
  ids: CategoryIds.MensShoes,
  table: /*#__PURE__*/React.createElement(MensShoes, {
    key: "mens-shoes"
  })
}, {
  ids: CategoryIds.WomensClothing,
  table: /*#__PURE__*/React.createElement(WomensClothing, {
    key: "womens-clothing"
  })
}, {
  ids: CategoryIds.WomensDualBottoms,
  table: /*#__PURE__*/React.createElement(WomensDualBottoms, {
    key: "womens-dual-bottoms"
  })
}, {
  ids: CategoryIds.WomensDualTops,
  table: /*#__PURE__*/React.createElement(WomensDualTops, {
    key: "womens-dual-tops"
  })
}, {
  ids: CategoryIds.WomensLingerie,
  table: /*#__PURE__*/React.createElement(WomensLingerie, {
    key: "womens-lingerie"
  })
}, {
  ids: CategoryIds.WomensShoes,
  table: /*#__PURE__*/React.createElement(WomensShoes, {
    key: "womens-shoes"
  })
}];
export var errorMessage = "\n  Oops, there isn\u2019t a size chart for this product right now.\n  To carry on shopping just close this pop-up box.\n";
export var fetchById = function fetchById(categoryId) {
  var tables = [];
  categories.forEach(function (category) {
    return category.ids.includes(categoryId) && tables.push(category.table);
  });
  if (!tables.length) return /*#__PURE__*/React.createElement("span", {
    className: "ac-size-guide__error"
  }, errorMessage);
  return tables;
};
export var fetchByType = function fetchByType(type) {
  var tables = [];
  var stripTypeName = type.replace(/ /g, '-').toLowerCase();
  categories.forEach(function (category) {
    return category.table.key === stripTypeName && tables.push(category.table);
  });
  if (!tables.length) return /*#__PURE__*/React.createElement("span", {
    className: "ac-size-guide__error"
  }, errorMessage);
  return tables;
};